// extracted by mini-css-extract-plugin
module.exports = {"text-url":"index_text-url__1rQfC"};